import { createFileRoute } from "@tanstack/react-router";

import { ConsoleBilling } from "../features/console/account";

export const Route = createFileRoute("/console/billing")({
  component: ConsoleBilling,
});
